export default __webpack_public_path__ + "static/media/warning.ff4969fd.svg";